import { setZoomConfig } from '@flow-engine/flow-detail/es/utils/zoom'


// 提前设置html的fontsize，防止页面渲染抖动
const configStr = localStorage.getItem('RATIO_CONFIG');
const rootBaseFontSize = 1
if (configStr) {
  const config = JSON.parse(configStr);
  if (config.ratioValue) {
    document.documentElement.style.fontSize = `${config.ratioValue * rootBaseFontSize}px`;

    setZoomConfig({
      toRem: (pixel: string | number) => {
        if (typeof pixel === 'string') {
          return pixel.split(/\s+/).map(p => (parseFloat(p) || 0) / rootBaseFontSize + 'rem').join(' ')
        } else {
          return pixel / rootBaseFontSize + 'rem'
        }
      },
      zoomRatio: config.ratioValue,
    })
  }
}